import "./index.css";

import DashboardStats from "./DashboardStats";

// vista de home insights
const Home = () => {

  return (
    <>
        <DashboardStats />
    </>
  );
};

export default Home;
